export const KeysIcon = () => (
  <svg
    width="24"
    height="13"
    viewBox="0 0 24 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3726 4.51638H12.6405C11.783 2.07978 9.46144 0.333374 6.73203 0.333374C3.27059 0.333374 0.45752 3.14645 0.45752 6.60788C0.45752 10.0693 3.27059 12.8824 6.73203 12.8824C9.46144 12.8824 11.783 11.136 12.6405 8.69939H13.0065L15.098 10.7909L17.1895 8.69939L19.281 10.7909L23.4641 6.56605L21.3726 4.51638ZM6.73203 9.74514C5.00654 9.74514 3.59477 8.33337 3.59477 6.60788C3.59477 4.88239 5.00654 3.47063 6.73203 3.47063C8.45752 3.47063 9.86928 4.88239 9.86928 6.60788C9.86928 8.33337 8.45752 9.74514 6.73203 9.74514Z"
      fill="#12191F"
    />
  </svg>
);
